import React, { useState } from 'react'
import {
  isNil,
  pathOr
} from 'ramda'
import ReactMarkdown from 'react-markdown'
// Local
import If from '../common/if'
import {
  formatIcd10Code,
  removeEmptyValues
} from './utils/utils'
import {
  EncounterConditionDisplayModified,
  User
} from '../authenticated/types'
import { truncatedDescription } from '../common/formatUtils'
import NLPExtractedLink from '../encounter/common/nlpExtractedLink'
import ConditionEvidence from '../encounter/common/conditionEvidence'

type Props = {
  currentUser: User
  condition: EncounterConditionDisplayModified
}

const maxCharactersAllowed = 200

const truncate = truncatedDescription(maxCharactersAllowed)

const hasDescriptionFor =
  (condition: EncounterConditionDisplayModified) =>
    (x: string): boolean =>
      !!pathOr('', [ x ], condition).length

function Description(props: Props): JSX.Element {
  const { currentUser, condition } = props

  const has = hasDescriptionFor(condition)

  const icd10CodeJsonToString: string = isNil(condition.icd10CodeJson)
    ? ''
    : condition.icd10CodeJson.map(formatIcd10Code).join(', ')

  const description = removeEmptyValues([
    condition.content,
    icd10CodeJsonToString
  ]) as string[]

  const shouldShowFullDescription =
    description.toString().length <= maxCharactersAllowed

  const [ shouldShowFullDescriptionState, setShouldShowFullDescriptionState ] =
    useState<boolean>(shouldShowFullDescription)

  return (
    <div className="curation-ui-description">
      <If isTrue={ shouldShowFullDescriptionState }>
        <If isTrue={ has('content') }>
          <ReactMarkdown>{ `**Reference:** ${description[0].replace('Reference: ', '') || ''}` }</ReactMarkdown>
          <ConditionEvidence
            condition={ condition }
            currentUser={ currentUser }
          />
          <NLPExtractedLink
            condition={ condition }
            currentUser={ currentUser }
          />
        </If>
        <If
          isTrue={ condition.isKnownAddressed && !!icd10CodeJsonToString.length }
        >
          <p>{ icd10CodeJsonToString }</p>
        </If>
      </If>
      { /* More Button */ }
      <If isTrue={ !shouldShowFullDescriptionState }>
        <If isTrue={ !(condition.content === null || condition.content === '') }>
          <span>
            <ReactMarkdown>{ `**Reference:** ${truncate(description[0]) || ''}...` }</ReactMarkdown>
          </span>
          <span
            className="curation-ui-description-toggle"
            onClick={ () => setShouldShowFullDescriptionState(true) }
          >
            More
          </span>
        </If>
      </If>
      { /* Less Button */ }
      <If isTrue={ !shouldShowFullDescription && shouldShowFullDescriptionState }>
        <span
          className="curation-ui-description-toggle"
          onClick={ () => setShouldShowFullDescriptionState(false) }
        >
          Less
        </span>
      </If>
    </div>
  )
}

export default Description
